import { render } from "./RegistrationUserStepTwo.vue?vue&type=template&id=61f4b738&scoped=true"
import script from "./RegistrationUserStepTwo.vue?vue&type=script&lang=js"
export * from "./RegistrationUserStepTwo.vue?vue&type=script&lang=js"

import "./RegistrationUserStepTwo.vue?vue&type=style&index=0&id=61f4b738&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f4b738"]])

export default __exports__